export const PROCESSING_OPTION_LABELS = {
  plCategory: "Assign P&L sections",
  taxAdjustment: "Suggest tax treatment",
  mergeAccounts: "Merge similar accounts",
  divergent: "Inference strictness",
};
